import { createContext, useContext } from "react";

import type { Me } from "@/lib/auth-api";
import type { ServiceProblem } from "@/lib/service-problems";

export type AuthStatus = "loading" | "anonymous" | "step" | "active" | "unavailable" | "error";

export interface AuthContextValue {
  status: AuthStatus;
  me: Me | null;
  problem: ServiceProblem | null;
  can: (permission: string) => boolean;
  canAny: (...permissions: string[]) => boolean;
  refresh: () => Promise<unknown>;
  signOut: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
  const value = useContext(AuthContext);
  if (!value) throw new Error("useAuth must be used inside AuthProvider");
  return value;
}

export const ADMIN_PERMISSIONS = [
  "admin.users",
  "admin.roles",
  "admin.import",
  "admin.themes",
  "admin.settings",
  "admin.audit",
];
